$(function () {
  let p = $('body').attr('p');
  let organizerId = $('body').attr('organizer_id');
  const body = $('body');
  let orderStorageIdentifierSelectAjaxLock = false;
  let isLongPress = false;
  let shop_type = $('body').attr('shop_type');
  let tableId =
    $('#event-public-list-organizer').attr('data-table-number') || null;
  let selectedTableNumber = '';
  let selectedTableId = '';

  if (p === 'events_self_service' && shop_type == 'dine-in') {
    function checkPaymentStatusByCustomerId(tableGuestId) {
      $.ajax({
        type: 'POST',
        url: '/api/v1/sessions/get-saved-order-table-guest-payment-status',
        data: {
          organizer_id: organizerId,
          table_id: tableId,
          guest_id: tableGuestId,
          shop_type,
        },
      })
        .done(function (response) {
          const { data } = response;
          if (data && data.isPaid == 0) {
            selectedTableId = localStorage.getItem('saved_table_id');
            selectedTableNumber = localStorage.getItem('saved_table_name');
            tableGuestId = localStorage.getItem('saved_table_guest_id');
            locationCart.table_number = localStorage.getItem('saved_table_id');
            $('#view-saved-table-contanier').attr(
              'data-table-id',
              selectedTableId
            );
            $('#view-saved-table-contanier').attr(
              'data-table-number',
              selectedTableNumber
            );
            $('#view-saved-table-contanier').attr(
              'data-table-guest-id',
              tableGuestId
            );
            $('#view-saved-table-contanier').removeClass('d-none');
            $('.save_order_self_service').attr(
              'data-identifier',
              selectedTableNumber
            );
            $('.save_order_self_service').attr('data-table-id', tableId);
            $('.save_order_self_service').attr(
              'data-table-customer_id',
              tableGuestId
            );
          } else {
            localStorage.removeItem('saved_table_id');
            localStorage.removeItem('saved_table_guest_id');
            localStorage.removeItem('saved_table_timestamp');
            emptyAllCart();
            $('#view-saved-table-contanier').addClass('d-none');
            $('#view-saved-table-contanier').attr('data-table-id', '');
            $('#view-saved-table-contanier').attr('data-table-guest-id', '');
            $('.save_order_self_service').attr('data-identifier', '');
            $('.save_order_self_service').attr('data-table-guest-id', '');

            // sendWhenReady(
            //   window.globalSocket,
            //   JSON.stringify({
            //     type: 'update_table_guest_products',
            //     table_guest_id: tableGuestId,
            //   })
            // );
          }
        })
        .fail(function (data) {
          if (
            data.responseJSON.message !== undefined &&
            data.responseJSON.message !== ''
          ) {
            // showToast({
            //   type: 'error',
            //   message: data.responseJSON.message,
            //   position: 'bottom-right',
            //   duration: 1500,
            // });
          }
          return false;
        });
    }

    $(document).on('visibilitychange', function () {
      if (!document.hidden) {
        const savedGuestId = localStorage.getItem('saved_table_guest_id');

        if (savedGuestId) {
          const savedTimestamp = localStorage.getItem('saved_table_timestamp');
          const twelveHours = 12 * 60 * 60 * 1000;
          const isExpired =
            savedTimestamp &&
            Date.now() - parseInt(savedTimestamp) > twelveHours;

          if (isExpired) {
            localStorage.removeItem('saved_table_id');
            localStorage.removeItem('saved_table_guest_id');
            localStorage.removeItem('saved_table_timestamp');
            emptyAllCart();
            $('#view-saved-table-contanier').addClass('d-none');
            $('#view-saved-table-contanier').attr('data-table-id', '');
            $('#view-saved-table-contanier').attr('data-table-guest-id', '');
            $('.save_order_self_service').attr('data-identifier', '');
            $('.save_order_self_service').attr('data-table-guest-id', '');
          } else {
            checkPaymentStatusByCustomerId(savedGuestId);
          }
        }
      }
    });

    if (
      localStorage.getItem('saved_table_id') &&
      localStorage.getItem('saved_table_guest_id')
    ) {
      checkPaymentStatusByCustomerId(
        localStorage.getItem('saved_table_guest_id')
      );
    }
  }

  if (p === 'events' || p === 'events_self_service') {
    if (tableId) {
      locationCart.table_number = tableId;
      selectedTableNumber = tableId;
      $('.save_order_self_service').attr(
        'data-identifier',
        selectedTableNumber
      );
    }

    const organizerId = $(body).attr('organizer_id');
    const error_message = $(body).attr('error_message') ?? null;
    let locationId =
      $('#classic-location-products').attr('data-location-id') ??
      $('#location').attr('data-location-id');
    let posType = $('#classic-location-products').attr('data-pos-type');
    let orderStorageIdentifierFormSubmitAjaxLock = false;

    if (error_message && localStorage.getItem('saved_table_id')) {
      selectedTableNumber = localStorage.getItem('saved_table_id');
    }

    $(document).on('click', '.self-service-table', function (e) {
      e.preventDefault();
      selectedTableNumber = $(this).attr('data-table-name');
      selectedTableId = $(this).attr('data-table-id');
      locationCart.table_number = selectedTableNumber;
      $('#self-service-table-select-btn').text(selectedTableNumber);
      $('.save_order_self_service').attr(
        'data-identifier',
        selectedTableNumber
      );
      $('.save_order_self_service').attr('data-table-id', selectedTableId);

      $('.save_order_self_service').attr('data-extra-table', '');
      $('#selfServiceTableModel').modal('hide');
      $('#cart-table-number').text(selectedTableNumber);
      $('.save_order_self_service').prop('disabled', false);
      $('#proceed-to-checkout').prop('disabled', false);
      $('.show-customer-name-collapse').prop('disabled', false);
      $('#self-service-action-wrapper').removeClass('d-none');
      $('#self-service-action-wrapper').addClass('d-flex');
      adjustProductsHeight();
    });

    $(document).on('click', '.show-customer-name-collapse', function (e) {
      if (localStorage.getItem('saved_table_guest_id')) {
        $('.save_order_self_service').attr(
          'data-table-guest-id',
          localStorage.getItem('saved_table_guest_id')
        );
        setTimeout(() => {
          $('.save_order_self_service').trigger('click');
        }, 200);
      } else if ($('#table-customer-name').val()) {
        $('.save_order_self_service').trigger('click');
      } else if ($(this).attr('aria-expanded') === 'true') {
        $(this).attr('aria-expanded', false);
        $('#table-customer-name-collapse').collapse('hide');
      } else {
        $(this).attr('aria-expanded', true);
        $('#table-customer-name-collapse').collapse('show');
      }
      setTimeout(() => {
        adjustProductsHeight();
      }, 500);
    });

    $(document).on('click', '#view-saved-table-contanier', function (e) {
      e.preventDefault();
      const guestId = $(this).attr('data-table-guest-id');
      const tableId = $(this).attr('data-table-id');
      const tableNumber = $(this).attr('data-table-number');
      const sessionTableId = $(this).attr('data-session-table-id');

      if (!guestId) {
        showToast({
          type: 'error',
          message: 'Ingen kundeinformasjon tilgjengelig for dette bordet.',
          position: 'bottom-right',
          duration: 1500,
        });
        return;
      }

      $.ajax({
        type: 'POST',
        url: '/api/v1/sessions/get-saved-guest-products',
        data: {
          organizer_id: organizerId,
          location_id: locationId,
          table_id: tableId,
          table_number: tableNumber,
          session_table_id: sessionTableId,
          guest_id: guestId,
          is_view_saved_product: 1,
        },
      })
        .done(function (response) {
          const { data } = response;
          if (data) {
            if (data.is_view_saved_product == 1) {
              isViewSavedProduct = true;
            }
            setLocationCart(data);
          }
        })
        .fail(function (data) {
          // Handle the error
        });
    });

    $(document).on('click', '#view-saved-table', function (e) {
      e.preventDefault();
      if (!orderStorageIdentifierSelectAjaxLock && !isLongPress) {
        orderStorageIdentifierSelectAjaxLock = true;

        if (locationCart.number_of_products == 0) {
          const identifier = $(this).attr('data-table-id');
          const tableCustomerId = $(this).attr('data-table-guest-id');
          const extraTable = '';
          const cart_products = [];
          locationCart.products = [];
          locationCart.customer_id = '';
          $('.customer-item').removeClass('selected');
          locationCart.checkout_type = '';
          $.ajax({
            type: 'POST',
            url: '/ajax/order/get_saved_order_table',
            data: {
              organizer_id: organizerId,
              location_id: locationId,
              table_id: identifier,
              extra_table_id: extraTable,
              table_customer_id: tableCustomerId,
              cart_products,
              shop_type,
              is_view_saved_product: 1,
            },
          })
            .done(function (data) {
              if (
                data.location_id !== undefined &&
                data.location_id !== null &&
                data.location_id == locationId
              ) {
                $('#order-storage-list-modal').modal('hide');
                $('.modal-backdrop').remove();
                if (data.is_view_saved_product == 1) {
                  isViewSavedProduct = true;
                }

                if (data.is_already_paid) {
                  localStorage.removeItem('saved_table_id');
                  localStorage.removeItem('saved_table_guest_id');
                  localStorage.removeItem('saved_table_timestamp');
                  data.table_number = '';
                  data.is_view_saved_product = 0;
                  isViewSavedProduct = false;
                }

                if (posType === 'classic') {
                  setClassicLocationCart({
                    ...data,
                    checkout_type: 'split',
                  });
                } else {
                  setLocationCart(data);
                }
              }
            })
            .fail(function (data) {
              if (
                data.responseJSON.redirect_url !== undefined &&
                data.responseJSON.redirect_url !== null
              ) {
                document.location.href = data.responseJSON.redirect_url;
              }
            })
            .always(function () {
              setTimeout(function () {
                orderStorageIdentifierSelectAjaxLock = false;
              }, 3000);
            });
        }
      }
    });

    $(document).on('hide.bs.modal', '#cart-modal', function (event) {
      $('.modal-backdrop').remove();
      orderStorageIdentifierSelectAjaxLock = false;
    });

    $(document).on('hide.bs.modal', '#payment-split-modal', function (event) {
      $('.modal-backdrop').remove();
    });

    $(document).on('click', '.save_order_self_service', function (e) {
      e.preventDefault();
      const button = $(this);

      if (
        (!button.attr('data-table-id') || button.attr('data-table-id') == '') &&
        selectedTableId
      ) {
        button.attr('data-table-id', selectedTableId);
        button.attr('data-identifier', selectedTableNumber);
      }

      if (!button.attr('data-table-id') || button.attr('data-table-id') == '') {
        $('.self-service-table').focus();
        return alert('Velg bord først');
      }

      selectedTableNumber = button.attr('data-identifier');
      selectedTableId = button.attr('data-table-id');
      const customerName = $('#table-customer-name').val();
      const cart_products = locationCart.products;
      const tableId = button.attr('data-table-id');

      if (!customerName && !localStorage.getItem('saved_table_guest_id')) {
        alert('please enter customer name');
        $('#table-customer-name').focus();
        return;
      }

      if (cart_products.length <= 0) {
        return alert('No item in cart');
      }

      $.ajax({
        type: 'POST',
        url: '/api/v1/sessions/save-dine-in-order-product',
        data: {
          organizer_id: organizerId,
          location_id: locationCart.location_id,
          table_id: tableId,
          cart_products,
          comment: locationCart.comment,
          customer_name: customerName,
          guest_id: localStorage.getItem('saved_table_guest_id') || '',
        },
      })
        .done(function (response) {
          const { data } = response;

          if (data && data.guest_id) {
            $('#view-saved-table-contanier').attr(
              'data-session-table-id',
              data.session_table_id
            );
            $('#view-saved-table-contanier').attr(
              'data-table-guest-id',
              data.guest_id
            );
            $('#view-saved-table-contanier').attr(
              'data-table-id',
              data.table_id
            );
            console.log('data.table_id', data.table_id);
            $('#view-saved-table-contanier').removeClass('d-none');
            emptyAllCart();
            popupAlert();
            $('#cart-modal').modal('hide');
            $('.table-responsive').empty();

            localStorage.setItem('saved_table_id', data.table_id);
            localStorage.setItem('table_session_id', data.session_table_id);

            localStorage.setItem('saved_table_name', selectedTableNumber);

            localStorage.setItem('saved_table_guest_id', data.guest_id);
            localStorage.setItem('saved_table_timestamp', Date.now());

            button.attr('data-table-guest-id', data.guest_id);
            button.attr('data-table-id', data.table_id);
          }
        })
        .fail(function (response) {
          const { data } = response;
          if (
            data.responseJSON.redirect_url !== undefined &&
            data.responseJSON.redirect_url !== null
          ) {
            document.location.href = data.responseJSON.redirect_url;
          }
        });
    });

    $(document).on('click', '#view-saved-table', function (e) {
      e.preventDefault();
    });

    $(document).on(
      'click',
      '#add-to-checkout, #add-to-cart-from-table',
      function () {
        const tableId = $(this).attr('data-identifier');
        const tableButton = $(`button[data-identifier="${tableId}"]`);
        const extraTable = tableButton.attr('data-extra-table');
        locationCart.products = [];
        locationCart.customer_id = '';
        $('.customer-item').removeClass('selected');
        locationCart.checkout_type = '';

        let addToCartFromTable = 1;

        if ($('#split-payment-cart-modal').length) {
          $('#split-payment-cart-modal').modal('hide');
        }

        if (!orderStorageIdentifierSelectAjaxLock) {
          orderStorageIdentifierSelectAjaxLock = true;
          $.ajax({
            type: 'POST',
            url: '/ajax/order/get_saved_order_table',
            data: {
              organizer_id: organizerId,
              location_id: locationId,
              table_id: tableId,
              extra_table_id: extraTable,
              cart_products: [],
              add_to_cart_from_table: addToCartFromTable,
            },
          })
            .done(function (data) {
              if (
                data.location_id !== undefined &&
                data.location_id !== null &&
                data.location_id == locationId
              ) {
                $('#order-storage-list-modal').modal('hide');
                if (posType === 'classic') {
                  if (data.unassigned_cart_products.length > 0) {
                    data.products = data.unassigned_cart_products;
                  }
                  setClassicLocationCart({
                    ...data,
                    checkout_type: 'normal',
                  });
                } else {
                  setLocationCart(data);
                }
              }
            })
            .fail(function (data) {
              if (
                data.responseJSON.redirect_url !== undefined &&
                data.responseJSON.redirect_url !== null
              ) {
                document.location.href = data.responseJSON.redirect_url;
              }
            })
            .always(function () {
              setTimeout(function () {
                orderStorageIdentifierSelectAjaxLock = false;
              }, 3000);
            });
        }
      }
    );

    $(document).on('click', '#close-context-menu', function () {
      if (!$('#context-menu').hasClass('d-none')) {
        $('#context-menu').addClass('d-none');
      }
      $('#order-storage-list-modal').find('.modal-content').css({
        height: 'auto',
      });

      $("#order-storage-list-modal button[aria-label='Close']").css({
        opacity: 1,
        pointerEvents: 'auto',
      });
    });

    $(document).on(
      'click',
      '#close-table-customer-context-menu, #table-customer-cancel',
      function () {
        if (!$('#table-customer-context-menu').hasClass('d-none')) {
          $('#table-customer-context-menu').addClass('d-none');
        }
        $('#order-storage-list-modal').find('.modal-content').css({
          height: 'auto',
        });

        $("#order-storage-list-modal button[aria-label='Close']").css({
          opacity: 1,
          pointerEvents: 'auto',
        });
      }
    );

    $(document).on('click', '#table-customer-save', function () {
      if (!$(this).attr('data-table-guest-id')) {
        return;
      }
      const identifier = $(this).data('identifier');
      const cart_products = locationCart.products;
      const tableCustomerId = $(this).attr('data-table-guest-id');

      if (!orderStorageIdentifierSelectAjaxLock) {
        orderStorageIdentifierSelectAjaxLock = true;
        $.ajax({
          type: 'POST',
          url: '/ajax/order/save_order_product',
          data: {
            organizer_id: organizerId,
            location_id: locationId,
            table_id: identifier,
            is_printed: window.ReactNativeWebView ? 1 : 0,
            cart_products,
            comment: locationCart.comment,
            table_customer_id: tableCustomerId,
          },
        })
          .done(function (data) {
            const totalAmount =
              $('#cart-amount-with-tips').attr('data-cart-amount-with-tips') ??
              $('#original-total-amount').text();

            showToast({
              type: 'success',
              message: `Sum ${totalAmount} og ${locationCart.number_of_products} varer satt på ${identifier}`,
              position: 'bottom-right',
              duration: 1500,
            });

            if (
              data.location_id !== undefined &&
              data.location_id !== null &&
              data.location_id == locationId
            ) {
              $('#order-storage-list-modal').modal('hide');
              $('#context-menu').hide();
              setTimeout(() => {
                emptyAllCart();
              }, 1000);
            }
            fetchDataAndSend();
            if (
              data &&
              data.orderData.length > 0 &&
              window.ReactNativeWebView
            ) {
              const currentDeviceId = localStorage.getItem('deviceID');
              if (
                data.mainPosDeviceId &&
                data.mainPosDeviceId !== currentDeviceId
              ) {
                checkDeviceActive(data.mainPosDeviceId).then(
                  function (isActive) {
                    if (isActive) {
                      let socketData = {
                        type: 'main-device-print-service',
                        main_pos_device_id: data.mainPosDeviceId,
                        requested_device_id: currentDeviceId,
                        printData: {
                          action: 'saved_table_print',
                          data: data.orderData,
                        },
                      };

                      window.globalSocket.send(JSON.stringify(socketData));
                    } else {
                      showToast({
                        type: 'error',
                        message:
                          'Kunne ikke skrive ut. Hoved-POS-enheten kan være inaktiv.',
                      });
                    }
                  }
                );
              } else {
                passDataToWebView(event, 'saved_table_print', data.orderData);
              }
            }
          })
          .fail(function (data) {
            if (
              data.responseJSON.redirect_url !== undefined &&
              data.responseJSON.redirect_url !== null
            ) {
              document.location.href = data.responseJSON.redirect_url;
            }
          })
          .always(function () {
            setTimeout(function () {
              orderStorageIdentifierSelectAjaxLock = false;
            }, 300);
          });
      }
    });

    $(document).on('click', '.table-customer-list-item', function () {
      const wasActive = $(this).hasClass('active');

      $('.table-customer-list-item').removeClass('active');
      if (!wasActive) {
        $(this).addClass('active');
        $('#table-customer-save').prop('disabled', false);
        $('#table-customer-save').attr(
          'data-table-guest-id',
          $(this).data('table-guest-id')
        );
      } else {
        $('#table-customer-save').prop('disabled', true);
        $('#table-customer-save').removeAttr('data-table-guest-id');
      }
    });

    // $(document).on(
    //   "mousedown touchstart",
    //   ".order-storage-list .order-storage-list-identifier",
    //   function (e) {
    //     const identifier = $(this).data("identifier");

    //     const hasPaidCustomer = $(this).attr("data-has-paid-customer") === "1";
    //     const numberOfProductsInCart = $("#order-storage-list-modal").attr(
    //       "data-cart-count",
    //     );
    //     if (Number(numberOfProductsInCart) > 0) {
    //       isLongPress = false;
    //       return;
    //     }

    //     longPressTimer = setTimeout(function () {
    //       isLongPress = true;

    //       if (locationCart.number_of_products > 0) {
    //         $.ajax({
    //           url: "/api/v1/private/product-table/get-table-customer-list-html",
    //           method: "POST",
    //           data: {
    //             table_id: identifier,
    //             organizer_id: organizerId,
    //           },
    //         })
    //           .done(function (data) {
    //             if (data && data.html != undefined && data.html != null) {
    //               showTableCustomerContextMenu(identifier, data.html);
    //             }
    //           })
    //           .fail(function (data) {
    //             if (
    //               data.responseJSON.redirect_url !== undefined &&
    //               data.responseJSON.redirect_url !== null
    //             ) {
    //               document.location.href = data.responseJSON.redirect_url;
    //             }
    //           });
    //       } else {
    //         showContextMenu(identifier, hasPaidCustomer);
    //       }
    //     }, 1500);
    //   },
    // );

    function showTableCustomerContextMenu(identifier, customerListHTML) {
      const contextMenuHeader = $('.table-customer-context-menu-header h5');

      $("#order-storage-list-modal button[aria-label='Close']").css({
        opacity: 0,
        pointerEvents: 'none',
      });

      contextMenuHeader.text(identifier);
      $('#table-customer-save').attr('data-identifier', identifier);
      $('#add-person').attr('data-table-id', identifier);
      $('#table-customer-list-container').html(customerListHTML);

      $('#order-storage-list-modal').find('.modal-content').css({
        height: '450px',
      });
      $('#table-customer-context-menu').removeClass('d-none');
    }

    function showContextMenu(identifier, hasPaidCustomer) {
      const contextMenu = $('#context-menu');
      const moveTableButton = $('#move-table');
      const extraTableButton = $('#extra-table');
      const deleteTableButton = $('#delete-table');
      const splitTableButton = $('#split-payment');
      const addToCheckoutButton = $('#add-to-checkout');
      const contextMenuHeader = $('.context-menu-header h5');

      $("#order-storage-list-modal button[aria-label='Close']").css({
        opacity: 0,
        pointerEvents: 'none',
      });

      contextMenu.attr('data-identifier', identifier);
      extraTableButton.attr('data-identifier', identifier);
      deleteTableButton.attr('data-identifier', identifier);
      moveTableButton.attr('data-identifier', identifier);
      splitTableButton.attr('data-identifier', identifier);
      addToCheckoutButton.attr('data-identifier', identifier);
      contextMenuHeader.text(identifier);

      if (hasPaidCustomer) {
        deleteTableButton.addClass('disabled');
        moveTableButton.addClass('disabled');
        addToCheckoutButton.addClass('disabled');
      } else {
        deleteTableButton.removeClass('disabled');
        moveTableButton.removeClass('disabled');
        addToCheckoutButton.removeClass('disabled');
      }

      $('#order-storage-list-modal').find('.modal-content').css({
        height: '450px',
      });
      $('#context-menu').removeClass('d-none');
    }

    $(document).on('click touchstart', '#context-menu', function (e) {
      e.stopPropagation();
    });

    $(document).on('submit', '#order-storage-identifier-form', function (e) {
      e.preventDefault();
      const identifier = $(
        '#order-storage-identifier-form #order-storage-identifier-new'
      ).val();
      const extraTable = $(this).attr('data-extra-table') ?? '';

      if (!orderStorageIdentifierFormSubmitAjaxLock && identifier != '') {
        orderStorageIdentifierFormSubmitAjaxLock = true;

        locationCart.order_storage_identifier = identifier;
        const cart_products = locationCart.products;

        $.ajax({
          type: 'POST',
          url: '/ajax/order/save_order_product',
          data: {
            organizer_id: organizerId,
            location_id: locationId,
            table_id: identifier,
            extra_table_id: extraTable,
            temporary_table: 1,
            cart_products,
            comment: locationCart.comment,
          },
        })
          .done(function (data) {
            const totalAmount =
              $('#cart-amount-with-tips').attr('data-cart-amount-with-tips') ??
              $('#original-total-amount').text();
            showToast({
              type: 'success',
              message: `Sum ${totalAmount} og ${locationCart.number_of_products} varer satt på ${identifier}`,
              position: 'bottom-right',
              duration: 1500,
            });

            fetchDataAndSend();
            if (
              data &&
              data.orderData.length > 0 &&
              window.ReactNativeWebView
            ) {
              const currentDeviceId = localStorage.getItem('deviceID');
              if (
                data.mainPosDeviceId &&
                data.mainPosDeviceId !== currentDeviceId
              ) {
                checkDeviceActive(data.mainPosDeviceId).then(
                  function (isActive) {
                    if (isActive) {
                      let socketData = {
                        type: 'main-device-print-service',
                        main_pos_device_id: data.mainPosDeviceId,
                        requested_device_id: currentDeviceId,
                        printData: {
                          action: 'saved_table_print',
                          data: data.orderData,
                        },
                      };

                      window.globalSocket.send(JSON.stringify(socketData));
                    } else {
                      showToast({
                        type: 'error',
                        message:
                          'Kunne ikke skrive ut. Hoved-POS-enheten kan være inaktiv.',
                      });
                    }
                  }
                );
              } else {
                passDataToWebView(event, 'saved_table_print', data.orderData);
              }
            }
            if (
              data.location_id !== undefined &&
              data.location_id !== null &&
              data.location_id == locationId
            ) {
              $('#order-storage-list-modal').modal('hide');
              emptyAllCart();
              popupAlert();

              orderStorageIdentifierSelectAjaxLock = false;
              orderStorageIdentifierFormSubmitAjaxLock = false;
            }
          })
          .fail(function (data) {
            if (
              data.responseJSON.redirect_url !== undefined &&
              data.responseJSON.redirect_url !== null
            ) {
              document.location.href = data.responseJSON.redirect_url;
            }
            if (
              data.responseJSON.error_message !== undefined &&
              data.responseJSON.error_message !== null
            ) {
              $('#message').remove();
              prependAlertUnClose(
                '.order-storage-list-container',
                data.responseJSON.error_message,
                'danger',
                null
              );
              $('#order-storage-identifier-new').focus();
            }
          })
          .always(function () {
            orderStorageIdentifierFormSubmitAjaxLock = false;
          });
      }
      return false;
    });

    $(document).on('click', '#to-directy-save-assign', function () {
      const identifier = $(this).data('identifier');
      const tableCustomerId = $(this).data('table-customer-id') ?? '';
      const cart_products = locationCart.products;
      const extraTable = $(this).attr('data-extra-table') ?? '';
      let productTableIds = $(this).data('product-table-ids');
      const addByOne = $(this).attr('data-add-one');
      if (typeof productTableIds === 'string') {
        try {
          productTableIds = JSON.parse(productTableIds);
        } catch (e) {
          console.error('Invalid JSON in data-product-table-ids', e);
          productTableIds = {};
        }
      }

      $.ajax({
        type: 'POST',
        url: '/ajax/order/save_order_product',
        data: {
          organizer_id: organizerId,
          location_id: locationId,
          table_id: identifier,
          extra_table_id: extraTable,
          cart_products,
          comment: locationCart.comment,
        },
      })
        .done(function (data) {
          const totalAmount =
            $('#cart-amount-with-tips').attr('data-cart-amount-with-tips') ??
            $('#original-total-amount').text();

          showToast({
            type: 'success',
            message: `Sum ${totalAmount} og ${locationCart.number_of_products} varer satt på ${identifier}`,
            position: 'bottom-right',
            duration: 1500,
          });

          if (data.location_id !== undefined && data.location_id !== null) {
            setTimeout(() => {
              emptyAllCart();
            }, 1000);
          }
          if (
            data.location_id == locationId &&
            data.currentSavedOrderData !== undefined &&
            data.currentSavedOrderData !== null
          ) {
            console.log(
              'Assigning products to current person' +
                JSON.stringify(data.currentSavedOrderData)
            );
            if (data.currentSavedOrderData.length > 0) {
              for (let i = 0; i < data.currentSavedOrderData.length; i++) {
                // $("#order-storage-list-modal").modal("hide");
                const productId = data.currentSavedOrderData[i].productId;
                const tableId = identifier;
                const currentSelectedPersonId = tableCustomerId;
                const currentProductTableId =
                  data.currentSavedOrderData[i].productTableId;
                console.log(
                  'currentProductTableId===>' + currentProductTableId
                );
                $.ajax({
                  type: 'POST',
                  url: '/ajax/order/update_product_table',
                  data: {
                    table_customer_id: currentSelectedPersonId,
                    product_id: productId,
                    table_id: tableId,
                    location_id: locationId,
                    location_type: locationCart.location_type,
                    product_table_id: currentProductTableId,
                    split_by_one: addByOne ? 1 : 0,
                  },
                })
                  .done(function (data) {
                    if (data.html !== undefined && data.html !== null) {
                      $('#split-payment-product-container').empty();
                      $('#split-payment-product-container').html(data.html);
                      softProductTableList();
                      softPersonProductTableList();
                    }

                    if (
                      data.location_id !== undefined &&
                      data.location_id !== null &&
                      data.location_id == locationCart.location_id
                    ) {
                      if (posType === 'classic') {
                        setClassicLocationCart(data);
                      } else {
                        setLocationCart(data);
                      }
                      selectedPersonCartData = data;
                      $(
                        `#customer-product-count-${currentSelectedPersonId}`
                      ).text(data.products.length || 0);
                    }

                    if (
                      data.disabled_switch !== undefined &&
                      data.disabled_switch !== null
                    ) {
                      $('#split-by-sum').prop('disabled', data.disabled_switch);
                    }
                  })
                  .fail(function (data) {
                    if (
                      data.responseJSON.redirect_url !== undefined &&
                      data.responseJSON.redirect_url !== null
                    ) {
                      document.location.href = data.responseJSON.redirect_url;
                    }
                  });
              }
            }
            //end of assign to current person
          }
        })
        .fail(function (data) {
          if (
            data.responseJSON.redirect_url !== undefined &&
            data.responseJSON.redirect_url !== null
          ) {
            document.location.href = data.responseJSON.redirect_url;
          }
        })
        .always(function () {
          setTimeout(function () {
            orderStorageIdentifierSelectAjaxLock = false;
          }, 300);
        });
    });

    $(document).on('click', '#print-advance-receipt', function () {
      const identifier = $('#context-menu').attr('data-identifier');

      $.ajax({
        type: 'POST',
        url: '/api/v1/private/printer/advance-receipt',
        data: {
          identifier,
          organizer_id: organizerId,
          location_id: locationId,
        },
      })
        .done(function (data) {
          if (data && data.print_data) {
            passDataToWebView(
              event,
              'advance_receipt',
              data.print_data.orderProducts,
              data.print_data.ipAddress,
              data.print_data.printerType,
              data.print_data.organizer
            );
          }

          $('#context-menu').hide();
        })
        .fail(function (data) {
          if (
            data.responseJSON.redirect_url !== undefined &&
            data.responseJSON.redirect_url !== null
          ) {
            document.location.href = data.responseJSON.redirect_url;
          }
        });
    });
    function softProductTableList() {
      if ($('.share-payment-product-list').length) {
        // Get the correct DOM element from jQuery
        const splitProductTableBody = $('.share-payment-product-list')[0];

        Sortable.create(splitProductTableBody, {
          handle: '.product-table-reorder',
          animation: 150,
          draggable: '.share-payment-product-container',
          ghostClass: 'sortable-ghost',
          forceFallback: true,
          dataIdAttr: 'data-product-table-id',
          store: {
            set: function (sortable) {
              let order = sortable.toArray();
              ajaxListOrder(order);
            },
          },
        });
      } else {
        console.error(
          'Error: .share-payment-product-list not found in the DOM!'
        );
      }
    }

    function softPersonProductTableList() {
      if ($('.share-payment-person-product-list').length) {
        const splitedProductTableBody = document.getElementsByClassName(
          'share-payment-person-product-list'
        )[0];

        Sortable.create(splitedProductTableBody, {
          handle: '.person-product-table-reorder',
          animation: 150,
          sort: true,
          delay: 0,
          touchStartThreshold: 0,
          disabled: false,
          draggable: '.share-payment-person-product-container',
          direction: 'vertical',
          ghostClass: 'sortable-ghost',
          dataIdAttr: 'data-product-table-id',
          removeCloneOnHide: true,
          store: {
            set: function (sortable) {
              let order = sortable.toArray();

              ajaxPersonProductListOrder(order);
            },
          },
        });
      }
    }
  }
});
